import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=1853574a&scoped=true&"
import script from "./InputText.vue?vue&type=script&lang=ts&"
export * from "./InputText.vue?vue&type=script&lang=ts&"
import style0 from "./InputText.vue?vue&type=style&index=0&id=1853574a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1853574a",
  null
  
)

export default component.exports